import React, { useState } from 'react';
import { FilterModalWrapper, FilterButtonWrapper } from './FilterModal.styles';
import Modal from '@iso/ui/Antd/Modal/Modal';
import filterIcon from '@iso/assets/images/localeats/homepage-header/filter-icon.svg';
import Checkbox from '@iso/ui/Antd/Checkbox/Checkbox';
import { Button } from '@iso/components/cbuielements/button';
import IntlMessages from '@iso/components/utility/intlMessages';
import { useSelector } from 'react-redux';

const FilterModal = ({ getFilterBrands }) => {
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [kitchensCollapse, setKitchensCollapse] = useState(false);
  const [categoryCollapse, setCategoryCollapse] = useState(false);
  const [dishesCollapse, setDishesCollapse] = useState(false);
  const [selectFilters, setSelectFilters] = useState([]);
  const filters = useSelector((state) => state.LocalEats.filters);

  const onOkClick = () => {
    setIsFilterModalVisible(false);
    getFilterBrands(selectFilters);
  };

  const onAddFilter = (e) => {
    setSelectFilters([
      ...selectFilters,
      {
        id: e.target.id,
        name: e.target.filter,
        type: e.target.filterType,
      },
    ]);
  };
  return (
    <>
      <FilterButtonWrapper>
        <div
          className="filter-button"
          // onClick={() => setIsFilterModalVisible(true)}
        >
          <img src={filterIcon} alt="" />
          FILTERS
          {/* <IntlMessages id="filters.button" /> */}
        </div>
      </FilterButtonWrapper>

      <Modal
        centered
        title={<IntlMessages id="filters.button" />}
        visible={isFilterModalVisible}
        onCancel={() => setIsFilterModalVisible(false)}
        footer={[
          <Button
            key="back"
            onClick={() => setIsFilterModalVisible(false)}
            style={{ background: 'white', color: 'gray' }}
          >
            <IntlMessages id="general.cancel" />
          </Button>,
          <Button
            style={{ background: '#ffa24b', color: 'white' }}
            key="submit"
            onClick={onOkClick}
          >
            <IntlMessages id="general.accept" />
          </Button>,
        ]}
      >
        <FilterModalWrapper>
          <div className="filter-modal-select-block">
            <p className="filter-title">
              <IntlMessages id="filter.button.kitchens" />
            </p>
            <div className="filter-items">
              <form>
                {filters &&
                  filters?.kitchens?.map(({ name, count, id }, index) => {
                    if (!kitchensCollapse) {
                      if (index < 4) {
                        return (
                          <div className="filter-item" key={id}>
                            <Checkbox
                              onChange={onAddFilter}
                              filter={name}
                              id={id}
                              filterType={'kitchens'}
                            >
                              <IntlMessages id={name} />

                              <span className="filter-item-count">
                                <sup> {count}</sup>
                              </span>
                            </Checkbox>
                          </div>
                        );
                      }
                    } else {
                      return (
                        <div className="filter-item" key={id}>
                          <Checkbox
                            onChange={onAddFilter}
                            filter={name}
                            id={id}
                            filterType={'kitchens'}
                          >
                            <IntlMessages id={name} />

                            <span className="filter-item-count">
                              <sup> {count}</sup>
                            </span>
                          </Checkbox>
                        </div>
                      );
                    }
                  })}

                <div
                  className="filter-read-more"
                  onClick={() => setKitchensCollapse((prevState) => !prevState)}
                >
                  {!kitchensCollapse && filters?.kitchens?.length > 4 && (
                    <IntlMessages id="filter.button.showAll" />
                  )}
                </div>
              </form>
            </div>
          </div>

          <div className="filter-modal-select-block">
            <p className="filter-title">
              <IntlMessages id="filter.button.dishes" />
            </p>
            <div className="filter-items">
              <form>
                {filters &&
                  filters?.dishes?.map(({ name, count, id }, index) => {
                    if (!categoryCollapse) {
                      if (index < 4) {
                        return (
                          <div className="filter-item" key={id}>
                            <Checkbox
                              onChange={onAddFilter}
                              filter={name}
                              id={id}
                              filterType={'dishes'}
                            >
                              <IntlMessages id={name} />

                              <span className="filter-item-count">
                                <sup> {count}</sup>
                              </span>
                            </Checkbox>
                          </div>
                        );
                      }
                    } else {
                      return (
                        <div className="filter-item" key={id}>
                          <Checkbox
                            onChange={onAddFilter}
                            filter={name}
                            id={id}
                            filterType={'dishes'}
                          >
                            <IntlMessages id={name} />

                            <span className="filter-item-count">
                              <sup> {count}</sup>
                            </span>
                          </Checkbox>
                        </div>
                      );
                    }
                  })}

                <div
                  className="filter-read-more"
                  onClick={() => setCategoryCollapse((prevState) => !prevState)}
                >
                  {!categoryCollapse && filters?.dishes?.length > 4 && (
                    <IntlMessages id="filter.button.showAll" />
                  )}
                </div>
              </form>
            </div>
          </div>

          <div className="filter-modal-select-block">
            <p className="filter-title">
              <IntlMessages id="filter.button.diets" />
            </p>

            <div className="filter-items">
              <form>
                {filters &&
                  filters?.diets?.map(({ name, count, id }, index) => {
                    if (!dishesCollapse) {
                      if (index < 4) {
                        return (
                          <div className="filter-item" key={id}>
                            <Checkbox
                              onChange={onAddFilter}
                              filter={name}
                              id={id}
                              filterType={'diets'}
                            >
                              <IntlMessages id={name} />

                              <span className="filter-item-count">
                                <sup> {count}</sup>
                              </span>
                            </Checkbox>
                          </div>
                        );
                      }
                    } else {
                      return (
                        <div className="filter-item" key={id}>
                          <Checkbox
                            onChange={onAddFilter}
                            filter={name}
                            id={id}
                            filterType={'diets'}
                          >
                            <IntlMessages id={name} />

                            <span className="filter-item-count">
                              <sup> {count}</sup>
                            </span>
                          </Checkbox>
                        </div>
                      );
                    }
                  })}

                <div
                  className="filter-read-more"
                  onClick={() => setDishesCollapse((prevState) => !prevState)}
                >
                  {!dishesCollapse && filters?.diets?.length > 4 && (
                    <IntlMessages id="filter.button.showAll" />
                  )}
                </div>
              </form>
            </div>
          </div>
        </FilterModalWrapper>
      </Modal>
    </>
  );
};

export default FilterModal;
